/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DropOffLocationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DropOffLocationsQuery = { __typename?: 'Query', dropOffLocations?: Array<{ __typename?: 'DropOffLocation', address: string, lat: number, lng: number, name: string, retailer?: string | null, suburb: string } | null> | null, currentUser?: { __typename?: 'User', lat?: number | null, lng?: number | null } | null };


export const DropOffLocationsDocument = gql`
    query DropOffLocations {
  dropOffLocations {
    address
    lat
    lng
    name
    retailer
    suburb
  }
  currentUser {
    lat
    lng
  }
}
    `;

/**
 * __useDropOffLocationsQuery__
 *
 * To run a query within a React component, call `useDropOffLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropOffLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropOffLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDropOffLocationsQuery(baseOptions?: Apollo.QueryHookOptions<DropOffLocationsQuery, DropOffLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DropOffLocationsQuery, DropOffLocationsQueryVariables>(DropOffLocationsDocument, options);
      }
export function useDropOffLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DropOffLocationsQuery, DropOffLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DropOffLocationsQuery, DropOffLocationsQueryVariables>(DropOffLocationsDocument, options);
        }
export function useDropOffLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DropOffLocationsQuery, DropOffLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DropOffLocationsQuery, DropOffLocationsQueryVariables>(DropOffLocationsDocument, options);
        }
export type DropOffLocationsQueryHookResult = ReturnType<typeof useDropOffLocationsQuery>;
export type DropOffLocationsLazyQueryHookResult = ReturnType<typeof useDropOffLocationsLazyQuery>;
export type DropOffLocationsSuspenseQueryHookResult = ReturnType<typeof useDropOffLocationsSuspenseQuery>;
export type DropOffLocationsQueryResult = Apollo.QueryResult<DropOffLocationsQuery, DropOffLocationsQueryVariables>;